import { render, staticRenderFns } from "./indexa.vue?vue&type=template&id=62406230&scoped=true"
import script from "./indexa.vue?vue&type=script&lang=js"
export * from "./indexa.vue?vue&type=script&lang=js"
import style0 from "./indexa.vue?vue&type=style&index=0&id=62406230&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62406230",
  null
  
)

export default component.exports